export const PerformanceSettingsTutorialKey = 'performanceSettings';
